import { createActionGroup, props } from '@ngrx/store';
import type { ApiTypes } from '../../..';
import type { GeneralRequestFormPayload, ReservationFormPayload, TestDriveFormPayload } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'distribution',
    events: {
        'Submit TestDrive Form': props<{ payload: TestDriveFormPayload; vehicle: ApiTypes.VehicleDetail }>(),
        'Submit GeneralRequest Form': props<{ payload: GeneralRequestFormPayload; vehicle: ApiTypes.VehicleDetail }>(),
        'Submit Reservation Form': props<{ payload: ReservationFormPayload; vehicle: ApiTypes.VehicleDetail }>(),
        'Submit Distribution Form Response': props<{ success: boolean }>(),
        'Submit Distribution Form Loading': props<{ loading: boolean }>(),
    },
});
